<footer>
  <p>
    Should you need help, please reach out to our
    <a class="support-link" href="mailto:support@example.com">support team.</a>
  </p>
</footer>
